<template>
  <Modal
    :id="'cmp-distribution-account_sidewindow-add_order'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('new_order')}}</template>

    <template slot="body">
      <div id="label_release_templates" class="form-group">
        <Dropdown
          :options="contra_accountsTV"
          class="m2"
          :selected="
            contra_accountsTV.find(
              (x) => x.value == selectedOrder.contra_account_id
            )
          "
          :placeholder="$t('stock_account')"
          v-on:selectedChange="(e) => onDropdownChange('contra_account_id', e)"
          box
          deselect
          :listHeight="200"
          showValidationIcons
          required
          :tabindex="1"
          immediateValidation
          @validated="(e) => onValidation('contra_account_id', e)"
        ></Dropdown>
        <TextField
          class="m1"
          :id="'order_reference'"
          :showValidationIcons="false"
          v-bind="textFieldConfig"
          :value="selectedOrder.order_reference"
          :placeholder="$t('custom_ref')"
          tabindex="2"
          @valuechanged="onTextFieldValueChange"
        ></TextField>

        <Dropdown
          :options="orderTypesTV"
          class="m2"
          :tabindex="3"
          :selected="
            orderTypesTV.find((x) => x.value == selectedOrder.order_type)
          "
          :placeholder="$t('type_string')"
          v-on:selectedChange="(e) => onDropdownChange('order_type', e)"
          box
          deselect
          :listHeight="500"
          :showValidationIcons="true"
          required
          immediateValidation
          @validated="(e) => onValidation('order_type', e)"
        ></Dropdown>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave"
      >
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { AccountService } from "../../services/account.service";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    InputField,
    Modal,
  },
  props: ["selectedAccountsDetails"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      validationResult: {},
      selectedOrder: {
        account_id: 0,
        order_reference: "",
        order_type: 0,
        contra_account_id: 0,
      },
    };
  },
  mounted: function () {
    this.fetcOrderFormData();
  },
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    contra_accountsTV: function () {
      return createTV(
        this.selectedOrder.contra_accounts,
        "account_name",
        "account_id"
      );
    },
    orderTypesTV: function () {
      return createTV(this.selectedOrder.order_types, "label", "value");
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    fetcOrderFormData: async function () {
      const result = await AccountService.getOrderAccount({
        account_id: this.selectedAccountsDetails?.account?.account_id,
      });
      console.log("result.data", result.data);
      this.selectedOrder = {
        ...result.data,
        ...this.selectedOrder,
        contra_account_id:  result.data.auto_contra_account?.account_id?result.data.auto_contra_account?.account_id:this.selectedAccountsDetails?.account?.contra_account_id,
        //order_type: result.data.auto_contra_account.default_order_type,
      };
    },
    onSave: async function () {
      const data = await AccountService.insertOrder({
        ...this.selectedOrder,
        account_id: this.selectedAccountsDetails?.account?.account_id,
      });
      const payload = data.data.order;
      this.$emit("added", {
        ...payload,
      });
    },
    onDropdownChange: function (name, value) {
      this.selectedOrder[name] = value.value;
    },
    onTextFieldValueChange: function (name, value) {
      this.selectedOrder[name] = value;
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-distribution-account_sidewindow-add_order {
  .dt-modal--body {
    margin-left: 0px;
  }
  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
}
</style>
